import {
  ROUTER_ABI,
  ROUTER_ADDRESS,
  SECH_TOKEN_DECIMAL,
  SWAP_TOKEN_DECIMALS,
  TOKEN_CONTRACT_ADDRESS,
  USDC_ARBITRUM_ADDRESS,
  WETH_ADDRESS
} from '@/constants'
import { IS_TESTNET, wagmiConfig } from '@/constants/walletConnectionConfig'
import { erc20Abi, parseEther, parseUnits } from 'viem'
import {
  writeContract,
  waitForTransactionReceipt,
  readContract
} from 'wagmi/actions'

export const swapTokensWithMetaMask = async (
  amountIn: string,
  amountOut: string,
  toAddress: string
) => {
  const deadline = Math.floor(Date.now() / 1000) + 60 * 3 // 1 minute

  // Define common path and functionName depending on IS_TESTNET
  let path: `0x${string}`[]
  let functionName: 'swapExactETHForTokens' | 'swapExactTokensForTokens'
  let args: any[]
  let value: bigint | undefined = undefined

  if (IS_TESTNET) {
    // ETH -> TOKEN
    const amountInWei = parseEther(amountIn)
    const minAmountOutWei = parseUnits(amountOut, SWAP_TOKEN_DECIMALS)

    path = [WETH_ADDRESS, TOKEN_CONTRACT_ADDRESS]
    functionName = 'swapExactETHForTokens'
    args = [minAmountOutWei, path, toAddress, deadline]
    value = amountInWei
  } else {
    // USDC -> TOKEN
    const amountInUSDC = parseUnits(amountIn, SWAP_TOKEN_DECIMALS)
    const minAmountOutToken = parseUnits(amountOut, SECH_TOKEN_DECIMAL)

    path = [USDC_ARBITRUM_ADDRESS, TOKEN_CONTRACT_ADDRESS]
    functionName = 'swapExactTokensForTokens'
    args = [amountInUSDC, minAmountOutToken, path, toAddress, deadline]
    value = undefined // No ETH value

    const allowance = await readContract(wagmiConfig, {
      address: USDC_ARBITRUM_ADDRESS,
      abi: erc20Abi,
      functionName: 'allowance',
      args: [toAddress as `0x${string}`, ROUTER_ADDRESS]
    })
    console.log('Allowance: ', allowance)

    // USDC token requires reset any existing allowance before making new approve request
    if (allowance && allowance < amountInUSDC) {
      const resetApproveHash = await writeContract(wagmiConfig, {
        address: USDC_ARBITRUM_ADDRESS,
        abi: erc20Abi,
        functionName: 'approve',
        args: [ROUTER_ADDRESS, 0n]
      })
      await waitForTransactionReceipt(wagmiConfig, {
        hash: resetApproveHash
      })
    }

    // Making approve only when allowance lower than needed
    // Approve required to for ERC20 tokens such as USDC
    if (allowance < amountInUSDC) {
      const approveHash = await writeContract(wagmiConfig, {
        address: USDC_ARBITRUM_ADDRESS,
        abi: erc20Abi,
        functionName: 'approve',
        args: [ROUTER_ADDRESS, amountInUSDC]
      })

      // Waiting for the transaction to be confirmed before swap to prevent allowance issue
      await waitForTransactionReceipt(wagmiConfig, {
        hash: approveHash
      })
    }
  }

  const transactionHash = await writeContract(wagmiConfig, {
    address: ROUTER_ADDRESS,
    abi: ROUTER_ABI,
    functionName,
    args,
    value
  })

  console.log(`Transaction submitted: ${transactionHash}`)

  const receipt = await waitForTransactionReceipt(wagmiConfig, {
    hash: transactionHash
  })

  console.log('Swap confirmed:', receipt)
  return receipt
}
